import { createFetchRetry } from '@rsos/capstone';
import { store } from '../../app/store';

export default createFetchRetry(store);
